<template>
  <div>
    <section
      :class="
        userData.isAndroid
          ? 'padding-nevigate-bar-ANDROID'
          : 'padding-nevigate-bar-IOS'
      "
      v-if="userData.channel != 'WEB'"
    >
      <div class="row no-gutters">
        <div class="col-2 pl-2 justify-content-center align-self-center">
          <div @click="goToPreviousPage()">
            <b-icon
              class="text-kanit-color-black"
              icon="chevron-left"
              style="width: 24px; height: 24px"
            />
          </div>
        </div>
        <div class="col-8 justify-content-center align-self-center">
          <div class="mx-0 text-center font-kanit-bold-20">
            {{ this.currentMenu.pageName }}
          </div>
        </div>
        <div class="col-2 px-0"></div>
      </div>
    </section>

    <div
      style="height: 95vh !important"
      :class="
        userData.isAndroid
          ? 'justify-content-md-center d-flex flex-column justify-content-between h-100 p-3'
          : ' d-flex flex-column justify-content-between h-100 p-3'
      "
    >
      <div>
        <div class="justify-content-center">
          <b-row style="margin-top: 24px">
            <b-col class="font-kanit-bold-16 text-kanit-color-black">
              {{ documentType.doc_short_name }}
            </b-col>
          </b-row>
          <div style="margin-top: 8px"></div>
          <div
            class="justify-content-md-center"
            v-for="(item, key) in documentType.list_doc"
            :key="key"
          >
            <div>
              <div class="row">
                <div class="col-10">
                  <b-row class="">
                    <b-col
                      cols="1"
                      class="text-center"
                      style="line-height: 24px"
                    >
                      <b-icon scale="2" icon="dot" style="color: #4457e3" />
                    </b-col>
                    <b-col class="text-left px-2">
                      <span
                        class="font-kanit-regular-16"
                        style="line-height: 1"
                        >{{ item }}</span
                      ></b-col
                    >
                  </b-row>
                </div>
              </div>
            </div>
          </div>
          <div
            class="w-100 hr-style"
            style="margin-top: 12px !important ; margin-bottom: 12px !important"
          />
          <div
            class="mb-1 d-flex justify-content-center"
            v-if="
              documentType.reason_request != undefined &&
              documentType.reason_request != ''
            "
          >
            <b-card class="mt-2 card-doc-err pt-1 pb-3" body-class="py-1">
              <b-row class="pt-1">
                <b-col cols="1">
                  <b-img center :src="iconInfo" width="24" height="24"></b-img>
                </b-col>
                <b-col>
                  <span
                    class="font-kanit-bold-16 card-doc-err-detail"
                    style="line-height: 24px"
                  >
                    {{ documentType.reason_request }}
                  </span>
                </b-col>
              </b-row>
              <b-row class="">
                <b-col cols="1"> </b-col>
                <b-col>
                  <span
                    class="font-kanit-regular-16 card-doc-err-detail"
                    style="line-height: 24px"
                  >
                    {{ documentType.reason_note }}
                  </span>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div class="mb-1">
            <div class="row">
              <div class="col-10">
                <b-row class="py-1">
                  <b-col class="font-kanit-bold-16 text-kanit-color-black">
                    {{ "เอกสารที่ต้องการแนบ" }}
                  </b-col>
                </b-row>
                <b-row class="">
                  <b-col>
                    <span class="font-kanit-regular-16 text-kanit-color-grey"
                      >รองรับไฟล์ JPG, PNG, HEIC และ PDF
                    </span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
        <b-overlay :show="isConvertingHeic" rounded="sm">
          <div>
            <b-card
              no-body
              v-if="getListFileByType().length > 0"
              class="border-radius-1rem"
              style="margin-top: 24px"
              body-class="py-0"
            >
              <!-- <b-container > -->
              <div
                v-for="(readItem, key) in getListFileByType()"
                v-bind:key="readItem.id"
              >
                <b-row
                  class="py-3 px-3 no-gutters"
                  align-v="center"
                  style="margin-right: 0px; margin-left: 0px"
                >
                  <b-col cols="auto mr-3">
                    <!-- <b-img
                      width="43"
                      height="43"
                      :src="getPreview(readItem.id)"
                      :class="'preview-' + getFileType(readItem.id)"
                      @click="viewDoc(readItem.id)"
                    ></b-img> -->

                    <template v-if="getFileType(readItem.id) == 'img'">
                      <b-img
                        width="43"
                        height="43"
                        :src="getPreview(readItem.id)"
                        :class="'preview-' + getFileType(readItem.id)"
                      ></b-img>
                    </template>
                    <template v-else>
                      <div class="preview-pdf text-center">
                        <b-img
                          style="margin-top: 12px"
                          width="18"
                          height="20"
                          :src="getPreview(readItem.id)"
                        ></b-img>
                      </div>
                    </template>
                  </b-col>

                  <!-- <b-col
                    cols="8"
                    class="text-muted"
                    @click="viewDoc(readItem.id)"
                    :id="'Upload_ViewDoc_' + readItem.type"
                    align-self="center"
                  > -->
                  <b-col
                    cols="8"
                    class="text-muted"
                    :id="'Upload_ViewDoc_' + readItem.type"
                    align-self="center"
                  >
                    <div
                      class="content-nowrap text-kanit-color-black font-kanit-regular-16"
                    >
                      {{ readItem.filename }}
                    </div>
                    <div class="font-kanit-regular-14 text-kanit-color-grey">
                      {{ getFileSize(readItem.filesize) }}
                    </div>
                    <div
                      v-if="documentType.state == 'error'"
                      class="font-kanit-regular-16 text-kanit-color-danger"
                    >
                      ไฟล์ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง
                    </div>
                  </b-col>
                  <template v-if="!checkDocIsSuccess()">
                    <b-col
                      cols="auto ml-auto"
                      class=""
                      @click="remove(readItem.id)"
                      style="cursor: pointer"
                    >
                      <div style="color: #4457e3">
                        <b-img
                          :id="'Upload_RemoveDoc_' + readItem.type"
                          :src="iconTrash"
                          width="24"
                          height="24"
                        ></b-img>
                      </div>
                    </b-col>
                  </template>
                </b-row>
                <b-row v-if="readItem.fileHavePassword" class="pb-3 mx-1">
                  <b-col>
                    <b-form-input
                      style="padding-top: 25px; line-height: 64px !important"
                      class="font-kanit-regular-16 input-password-custom"
                      :type="readItem.showPassword ? 'text' : 'password'"
                      aria-describedby="input-live-help input-live-feedback"
                      @blur="validateFileHavePassword(readItem, $event)"
                      :state="readItem.fileCheckassword"
                    ></b-form-input>
                    <span
                      style="padding-left: 16px"
                      :class="
                        'floating-label-' +
                        readItem.floatingPassword +
                        ' floating-text-' +
                        readItem.fileCheckassword
                      "
                      >รหัสผ่านเอกสาร</span
                    >
                    <b-img
                      style="margin-right: 16px !important"
                      @click="onShowPassword(readItem)"
                      :class="'password-icon-' + readItem.showPassword"
                      :src="readItem.showPassword ? iconCloseEye : iconEye"
                      width="24"
                      :height="readItem.showPassword ? '12' : '24'"
                    />
                    <b-form-invalid-feedback
                      id="input-live-feedback"
                      class="text-kanit-color-danger font-kanit-regular-14 px-2"
                    >
                      รหัสผ่านไม่ถูกต้อง
                    </b-form-invalid-feedback>
                  </b-col>
                </b-row>
                <div v-if="key + 1 != getListFileByType().length">
                  <div class="w-100 hr-style" />
                </div>
              </div>

              <!-- </b-container> -->
            </b-card>
            <div
              v-if="!checkDocIsSuccess()"
              class="pb-3 d-flex justify-content-center pt-0"
              style="padding-top: 24px !important"
            >
              <input
                id="fileUpload"
                @change="onFileChange($event)"
                type="file"
                multiple
                hidden
                :accept="acceptFile"
              />

              <input
                id="fileBrowseImage"
                @change="onFileChange($event)"
                type="file"
                hidden
                multiple
                accept="image/jpeg,image/png,image/jpg,image/heic"
              />

              <input
                id="fileBrowseIOS"
                @change="onFileChange($event)"
                type="file"
                hidden
                multiple
                accept="image/jpeg,image/png,image/jpg,image/heic,application/pdf"
              />

              <input
                id="fileBrowseFile"
                @change="onFileChange($event)"
                type="file"
                hidden
                accept="application/pdf"
              />

              <input
                id="fileCamera"
                @change="onFileChange($event)"
                type="file"
                capture
                hidden
                accept="image/jpeg,image/png,image/jpg,image/heic"
              />
              <button
                style="height: 56px"
                :id="'upload_chooseFiles_' + documentType.doc_code"
                @click="chooseFiles()"
                class="upload-button"
                :disabled="checkDocIsSuccess()"
              >
                <b-img :src="iconUploads" width="24" height="24" />

                <span
                  style="line-height: 24px; margin-left: 8px"
                  :class="
                    checkDocIsSuccess()
                      ? 'font-kanit-bold-16 text-kanit-color-grey '
                      : 'font-kanit-bold-16 text-kanit-color-blue'
                  "
                  >เลือกเอกสาร
                </span>
              </button>
            </div>
            <div v-if="!checkDocIsSuccess()">
              <div
                v-if="!checkLimit()"
                class="pt-3 text-kanit-color-danger font-kanit-regular-14 text-center"
              >
                กรุณาลดขนาดไฟล์และลองใหม่อีกครั้ง
              </div>
              <!-- <div v-if="!validateTotalPdf()" class="pt-3 text-danger">
                กรุณากรอกรหัสผ่านไฟล์ให้ครบถ้วน
              </div> -->
              <div class="pt-2">
                <b-progress
                  :value="getAllSize()"
                  :variant="getColorProgress()"
                  :max="max"
                  class="mb-2 progress-upload-custom"
                ></b-progress>
              </div>
              <b-row class="size-memory py-1 text-center">
                <b-col>
                  <span class="font-kanit-regular-14 text-kanit-color-grey"
                    >ใช้ไปแล้ว
                  </span>
                  <span
                    :class="!checkLimit() ? 'text-kanit-color-danger' : ''"
                    class="font-kanit-regular-14 text-kanit-color-grey"
                    >{{ getAllSize() + "/" + max }}</span
                  >
                  <span class="font-kanit-regular-14 text-kanit-color-grey">
                    MB
                  </span></b-col
                >
              </b-row>
            </div>
          </div>
        </b-overlay>
      </div>
      <div v-if="!checkDocIsSuccess()">
        <button
          class="btn btn-block btn-submit-landing-page"
          @click="doSubmit()"
          id="Upload_Accept"
          :disabled="
            !checkLimit() ||
            !validateTotalPdf() ||
            realFiles.length == 0 ||
            checkDocIsError()
          "
        >
          <template> ยืนยันการเลือกเอกสาร </template>
        </button>
      </div>
    </div>

    <b-modal
      v-model="modalShow"
      hide-header
      hide-header-close
      hide-footer
      centered
      content-class="modal-attachfile-modal_content"
      dialog-class="mb-4"
    >
      <div class="px-3 pb-4 justify-content-center">
        <b-row>
          <b-col align-self="start"
            ><span class="font-kanit-regular-16 text-kanit-color-disables"
              >เลือกรูปแบบ</span
            ></b-col
          >
          <b-col align-self="end" cols="2" style="text-align: right">
            <b-img
              width="24"
              height="24"
              style="cursor: pointer"
              :src="imgSystemClose"
              @click="modalShow = !modalShow"
            ></b-img
          ></b-col>

          <div class="w-100 px-3"><hr /></div>
          <b-col
            @click="selectedOptionFile(1)"
            :id="'upload_file_camera_' + documentType.doc_code"
          >
            <b-img
              left
              :src="iconCamera"
              height="20"
              width="20"
              style="margin-top: 2px"
            ></b-img>
            <span class="px-3 font-kanit-regular-16 text-kanit-color-grey"
              >ถ่ายรูป</span
            >
          </b-col>
          <div class="w-100 px-3"><hr /></div>
          <b-col
            @click="selectedOptionFile(2)"
            :id="'upload_file_browseImages_' + documentType.doc_code"
          >
            <b-img
              left
              :src="iconBrowseImages"
              height="20"
              width="20"
              style="margin-top: 2px"
            ></b-img>
            <span class="px-3 font-kanit-regular-16 text-kanit-color-grey"
              >อัลบั้มรูป</span
            >
          </b-col>
          <div class="w-100 px-3"><hr /></div>
          <b-col
            @click="selectedOptionFile(3)"
            :id="'upload_file_browseFiles_' + documentType.doc_code"
          >
            <b-img
              left
              :src="iconBrowseFile"
              height="20"
              width="20"
              style="margin-top: 2px"
            ></b-img>
            <span
              style="margin-left: 4px"
              class="px-3 font-kanit-regular-16 text-kanit-color-grey"
              >เลือกไฟล์</span
            >
          </b-col>
          <div class="w-100 pb-3"></div>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      v-model="modalShowBackStep"
      hide-header
      hide-header-close
      hide-footer
      content-class="content-dialog-back"
    >
      <div class="justify-content-center py-4">
        <b-row>
          <b-col style="text-align: center"
            ><span class="font-kanit-bold-20 text-kanit-color-black"
              >ยืนยันการออกจากหน้านี้?</span
            ></b-col
          >
        </b-row>
        <b-row class="pt-2">
          <b-col style="text-align: center">
            <span class="font-kanit-regular-16 text-kanit-color-black"
              >เอกสารที่เลือกไว้จะไม่ถูกบันทึก</span
            ></b-col
          >
        </b-row>

        <b-row class="pt-4">
          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-ktb-cancel btn-cancel-file-duplication"
              @click="closeModalShowBackStep()"
            >
              <span class="">ยกเลิก</span>
            </b-button>
          </b-col>

          <b-col cols="6">
            <b-button
              class="btn-block btn btn-info btn-confirm-file-duplication"
              @click="backPage()"
            >
              <span class="">ออกจากหน้านี้</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- modal password -->

    <template v-if="userData.isAndroid">
      <b-modal
        v-model="modalPassword"
        hide-header
        hide-header-close
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        no-enforce-focus
        no-stacking
        no-fade
        content-class="content-dialog-back"
      >
        <div class="justify-content-center pb-2">
          <b-row>
            <b-col style="text-align: center"
              ><span class="font-kanit-bold-20 text-kanit-color-black"
                >กรุณาระบุรหัสผ่านเอกสาร</span
              >
            </b-col>
          </b-row>
          <b-row class="pt-4">
            <b-col>
              <b-form-input
                style="
                  padding-top: 25px;
                  line-height: 64px !important;
                  color: #212121;
                "
                class="font-kanit-regular-16 input-password-custom"
                :type="tmpFilePassword.showPassword ? 'text' : 'password'"
                aria-describedby="input-live-help input-live-feedback"
                @input="onblurModalPdfPassword()"
                :state="tmpFilePassword.fileCheckassword"
                v-model="tmpFilePassword.input_password"
              ></b-form-input>
              <span
                class="px-2"
                :class="
                  'floating-label-' +
                  tmpFilePassword.floatingPassword +
                  ' floating-text-' +
                  tmpFilePassword.fileCheckassword
                "
                >รหัสผ่านเอกสาร</span
              >
              <b-img
                style="margin-right: 16px !important"
                @click="onShowPassword(tmpFilePassword)"
                :class="'password-icon-' + tmpFilePassword.showPassword"
                :src="tmpFilePassword.showPassword ? iconCloseEye : iconEye"
                width="24"
                :height="tmpFilePassword.showPassword ? '12' : '24'"
              />
              <b-form-invalid-feedback
                id="input-live-feedback"
                class="text-kanit-color-danger font-kanit-regular-14 px-2"
              >
                รหัสผ่านไม่ถูกต้อง
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="pt-4">
            <b-col cols="6">
              <b-button
                class="btn-block btn btn-info btn-ktb-cancel btn-cancel-file-duplication"
                @click="closeModalPdfPassword()"
              >
                <span style="font-size: 18px">ยกเลิก</span>
              </b-button>
            </b-col>

            <b-col cols="6">
              <b-button
                class="btn btn-block btn-submit-landing-page"
                @click="validateModalPdfPassword(tmpFilePassword)"
                :disabled="
                  tmpFilePassword.input_password == undefined ||
                  tmpFilePassword.input_password.length == 0 ||
                  tmpFilePassword.fileCheckassword == false
                "
              >
                <span style="">ยืนยัน</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </template>

    <template v-else>
      <b-modal
        v-model="modalPassword"
        hide-header
        hide-header-close
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        no-enforce-focus
        no-stacking
        content-class="content-dialog-back"
      >
        <div class="justify-content-center pb-2">
          <b-row>
            <b-col style="text-align: center"
              ><span class="font-kanit-bold-20 text-kanit-color-black"
                >กรุณาระบุรหัสผ่านเอกสาร</span
              >
            </b-col>
          </b-row>
          <b-row class="pt-4">
            <b-col>
              <b-form-input
                style="
                  padding-top: 25px;
                  line-height: 64px !important;
                  color: #212121;
                "
                class="font-kanit-regular-16 input-password-custom"
                :type="tmpFilePassword.showPassword ? 'text' : 'password'"
                aria-describedby="input-live-help input-live-feedback"
                @input="onblurModalPdfPassword()"
                :state="tmpFilePassword.fileCheckassword"
                v-model="tmpFilePassword.input_password"
              ></b-form-input>
              <span
                class="px-2"
                :class="
                  'floating-label-' +
                  tmpFilePassword.floatingPassword +
                  ' floating-text-' +
                  tmpFilePassword.fileCheckassword
                "
                >รหัสผ่านเอกสาร</span
              >
              <b-img
                style="margin-right: 16px !important"
                @click="onShowPassword(tmpFilePassword)"
                :class="'password-icon-' + tmpFilePassword.showPassword"
                :src="tmpFilePassword.showPassword ? iconCloseEye : iconEye"
                width="24"
                :height="tmpFilePassword.showPassword ? '12' : '24'"
              />
              <b-form-invalid-feedback
                id="input-live-feedback"
                class="text-kanit-color-danger font-kanit-regular-14 px-2"
              >
                รหัสผ่านไม่ถูกต้อง
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="pt-4">
            <b-col cols="6">
              <b-button
                class="btn-block btn btn-info btn-ktb-cancel btn-cancel-file-duplication"
                @click="closeModalPdfPassword()"
              >
                <span style="font-size: 18px">ยกเลิก</span>
              </b-button>
            </b-col>

            <b-col cols="6">
              <b-button
                class="btn btn-block btn-submit-landing-page"
                @click="validateModalPdfPassword(tmpFilePassword)"
                :disabled="
                  tmpFilePassword.input_password == undefined ||
                  tmpFilePassword.input_password.length == 0 ||
                  tmpFilePassword.fileCheckassword == false
                "
              >
                <span style="">ยืนยัน</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </template>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry.js";
import heic2any from "heic2any";
export default {
  data() {
    return {
      isConvertingHeic: false,
      imgBgNEXT: require("@/assets/images/Upload Documents@3x.png"),
      iconUploads: require("@/assets/images/ic_add_file.png"),
      iconTrash: require("@/assets/images/ic_trash.png"),
      iconCamera: require("@/assets/images/ic_camera.png"),
      iconBrowseFile: require("@/assets/images/ic_file.png"),
      iconBrowseImages: require("@/assets/images/ic_image.png"),
      iconInfo: require("@/assets/images/ic_info_resubmit.png"),
      iconEye: require("@/assets/images/ic_eye.png"),
      iconCloseEye: require("@/assets/images/ic_eye_close.png"),
      imgSystemClose: require("@/assets/images/ic_close_upload.png"),
      max: 0,
      documentType: {},
      maxsize: parseInt(process.env.VUE_APP_MAXSIZE),
      limit: parseInt(process.env.VUE_APP_LIMITFILE),
      acceptFile: process.env.VUE_APP_ACCEPTFILE,
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      userData: {},
      isalert: false,
      visible: false,
      modalShow: false,
      modalShowBackStep: false,
      size: 0,
      file: {
        option: null,
        placeholder: "กรุณาเลือกประเภทของข้อมูล",
      },
      files: [],
      realFiles: [],
      fileCountId: 0,
      collapseObj: {},
      fileGroupList: [],
      GroupDocDisplay: [],
      alert: {
        title: null,
        textclose: null,
        size: {
          title: "ขนาดไฟล์เกินกำหนด",
          detail:
            "ขนาดรวมของไฟล์ทั้งหมดจะต้องไม่เกิน " +
            process.env.VUE_APP_MAXSIZE +
            " MB",
          close: "ตกลง",
        },
        data: {
          title: "ยังไม่ได้เลือกไฟล์",
          detail: "กรุณาตรวจสอบและเลือกไฟล์เอกสารอีกครั้ง",
          close: "ตกลง",
        },
        typefile: {
          title: "เอกสารของคุณใช้รูปแบบไฟล์ที่ไม่รองรับ",
          detail: "เอกกสารต้องเป็นไฟล์ JPG, PNG, HEIC หรือ PDF",
          close: "ตกลง",
        },
        option: {
          title: "ไม่พบประเภทข้อมูล",
          detail: "กรุณาตรวจสอบและเลือกประเภทข้อมูลที่ต้องการเพิ่ม",
          close: "ตกลง",
        },
        filenameDuplicate: {
          title: "ชือไฟล์ซ้ำในระบบ",
          detail: "กรุณาเปลี่ยนชื่อไฟล์แล้วกรุณาลองใหม่อีกครั้ง",
          close: "ตกลง",
        },
        error: {
          title: "เกิดข้อผิดพลาด",
          detail:
            "เกิดข้อผิดพลาดในการประมวลผลข้อมูลจากระบบ กรุณาลองใหม่อีกครั้ง",
          close: "ตกลง",
        },
        sizeAndTypeFile: {
          title: "กรุณาตรวจสอบไฟล์",
          detail:
            "ประเภทของไฟล์ที่รองรับได้แก่ .pdf, .png, .jpg หรือ .heic เท่านั้น โดยขนาดข้อมูลรวมกันต้องมีขนาดไม่เกิน " +
            process.env.VUE_APP_MAXSIZE +
            " MB",
          close: "ตกลง",
        },
        fileEmpty: {
          title: "ขนาดไฟล์ไม่ถูกต้อง",
          detail: "กรุณาตรวจสอบขนาดไฟล์อีกครั้ง",
          close: "ตกลง",
        },
        fileSizeZero: {
          title: "ไม่สามารถเปิดไฟล์ได้",
          detail: "กรุณาตรวจสอบไฟล์อีกครั้ง",
          close: "ตกลง",
        },
      },
      form: {
        title: "อัปโหลดไฟล์เอกสาร",
        file_label: "กรุณาเลือกไฟล์",
        add: "เพิ่มเอกสาร",
        view: "ดูเอกสาร",
        remove: "นำออก",
        credit: {
          title: "คํารับรองการขอสินเชื่อ",
          detail:
            "ข้าพเจ้าขอรับรองว่าข้อความและ/หรือเอกสารที่ข้าพเจ้าได้แจ้งและ/หรือจัดส่งให้แก่ธนาคารนี้เป็นข้อมูลปัจจุบัน ถูกต้องและตรงตามความเป็นจริงทุกประการ และหากมีการแก้ไขเปลี่ยนแปลงข้อมูลและ/หรือเอกสารใดที่ได้ให้ไว้กับธนาคาร ข้าพเจ้าจะแจ้งให้ธนาคารทราบทันที",
        },
        confirm: "ยอมรับ",
        cancel: "ยกเลิก",
      },
      docTypeItem: {},
      listMsg: [
        "กดปุ่มเลือกไฟล์เอกสาร และจึงเลือกไฟล์เอกสาร PDF หรือรูปภาพ PNG, JPEG หรือ HEIC ที่ต้องการนำส่ง",
        "หากมีไฟล์เอกสารหลายหน้า สามารถกดเลือกไฟล์เอกสารเพิ่มได้",
        "ตรวจสอบความถูกต้องของไฟล์เอกสารทั้งหมดที่เลือก และตรวจสอบว่าขนาดรวมของไฟล์ทุกไฟล์และทุกประเภท จะไม่เกิน 20 MB",
        "กดปุ่มอัปโหลดไฟล์เอกสารที่อยู่ล่างสุด และโปรดรอสักครู่ระหว่างรอไฟล์เอกสารทั้งหมดอัปโหลด",
      ],
      ImgProps: { width: 30, height: 30 },
      showStatusImg: {
        0: "",
        1: "ไฟล์ใช้ไม่ได้",
        2: "รูปภาพไม่ชัดเจน",
        3: "อัปโหลดสำเร็จ",
        4: "ไฟล์ไม่สมบูรณ์",
        5: "อัปโหลดไม่สำเร็จ",
        6: "กำลังประมวลผล",
        99: "ไฟล์มีปัญหา",
      },
      grp_id: null,
      currentMenu: null,
      tmpFilePassword: {},
      modalPassword: false,
      showLoading: false,
    };
  },
  created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    this.userData = this.$store.getters.getUserData;
    this.grp_id = this.userData.grpId;
    this.currentMenu = {
      pageCode: "CommonUpload",
      pageName: this.userData.document_group_type.find(
        (i) => i.grp_id == this.userData.grpId
      ).grp_name,
      previousPage: this.userData.routerPath.documentGroup,
      params: { grpId: this.userData.grpId },
      isShow: true,
    };
    this.$event.$emit("update_current_menu", this.currentMenu);

    if (!this.userData.token) this.goLandingPage();
    this.documentType = this.userData.documentType.find(
      (v) => v.doc_code == this.$route.params.doc_code
    );
    if (this.documentType === undefined) this.goLandingPage();
    try {
      if (
        this.documentType.doc_desc != undefined &&
        this.documentType.doc_desc.length > 0
      ) {
        this.documentType.list_doc = this.documentType.doc_desc.split("|");
      }
    } catch (error) {
      console.error(error);
    }

    this.max = this.maxsize;
    if (this.documentType.max_size != undefined) {
      this.max = this.documentType.max_size;
    }
    try {
      this.onReceiveNativeCommand();
    } catch (error) {
      console.error(error);
    }

    window.onMobileBackPressed = function () {
      console.log("onMobileBackPressed");
      this.goToPreviousPage();
      return true;
    };
  },
  mounted() {
    try {
      this.initData();
      //Order Display
      if (this.files.filter((item) => !item.deviate_flag).length > 0)
        this.GroupDocDisplay.push(
          this.files.filter((item) => !item.deviate_flag)
        );
      if (this.files.filter((item) => item.deviate_flag).length > 0)
        this.GroupDocDisplay.push(
          this.files.filter((item) => item.deviate_flag)
        );
    } catch (error) {
      this.goLandingPage();
    }
  },
  methods: {
    onReceiveNativeCommand() {
      window["onReceiveNativeCommand"] = (commandName, payload) => {
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;
        console.log("commandName: " + commandName, "value: " + payload);
        if (commandName == "openCamera") {
          if (isAndroid) {
            document.getElementById("fileCamera").click();
          } else {
            document.getElementById("fileBrowseIOS").click();
          }
        } else if (commandName == "openGallery") {
          if (isAndroid) {
            document.getElementById("fileBrowseImage").click();
          } else {
            document.getElementById("fileBrowseIOS").click();
          }
        }
      };
    },
    initData() {
      // this.docTypeItem = this.userData.documentType.find(
      //   (v) => v.doc_code == this.$route.params.doc_code
      // );
      if (this.documentType.filesReal) {
        this.realFiles.push(...this.documentType.filesReal);
      }
      this.realFiles.forEach((f) => {
        if (f.filesize != undefined) {
          this.size = this.size + parseInt(f.filesize);
        }
      });
      let value = this.documentType;
      let files = [];
      //Create file
      let item = {
        type: value.doc_code,
        name: value.doc_name,
        file: null,
      };
      let fieldList = Object.keys(value);
      for (let key of fieldList) {
        item[key] = value[key];
      }
      files.push(item);
      this.collapseObj[value.doc_code] = true;

      //Create fileGroupList
      let found = this.fileGroupList.find((v) => v.doc_group == value.doc_code);
      if (!found) {
        let groupItem = {
          doc_group: value.doc_code,
          doc_condition: value.doc_condition,
        };
        if (!groupItem.doc_group || !groupItem.doc_condition)
          groupItem.doc_group = value.doc_code;
        this.fileGroupList.push(groupItem);
      }

      this.files = files;
    },
    chooseFiles() {
      if (this.userData.isAndroid) {
        this.openDialogChooseFile();
      } else {
        this.defaultPopupIOS();
      }
    },

    defaultPopupIOS() {
      try {
        document.getElementById("fileCamera").setAttribute("onclick", null);
        document
          .getElementById("fileCamera")
          .setAttribute(
            "onclick",
            'document.getElementById("fileBrowseIOS").click(); return false;'
          );

        this.$callback.requestCamera();
      } catch (error) {
        document.getElementById("fileUpload").click();
      }
    },

    selectedOptionFile(type) {
      try {
        if (type == 1) {
          try {
            this.$callback.requestCamera();
          } catch (error) {
            document.getElementById("fileCamera").click();
          }
        } else if (type == 2) {
          try {
            this.$callback.requestGallery();
          } catch (error) {
            document.getElementById("fileBrowseImage").click();
          }
        } else if (type == 3) {
          document.getElementById("fileBrowseFile").click();
        } else {
          document.getElementById("fileUpload").click();
        }
      } catch (error) {
        // document.getElementById("fileUpload").click();
      }
    },
    openDialogChooseFile() {
      this.modalShow = true;
    },

    async onFileChange(e) {
      console.log("HI");
      this.modalShow = false;
      let key = this.$route.params.doc_code;

      let docTypeItem = this.userData.documentType.find(
        (v) => v.doc_code == key
      );

      const files = e?.target?.files || e?.dataTransfer?.files;
      let isErrorSize = false;
      let isErrorTypeFile = false;
      let isErrorEmptyFile = false;
      let isErrorFileSizeZero = false;
      let isErrorFileNameDuplicate = false;
      let filenameDup = [];
      if (files?.length) {
        for (let file of files) {
          const size = this.size + file.size + 20;
          if (file.size > 0 && file.size > this.max * 1000000) {
            isErrorEmptyFile = true;
          } else if (file.size == 0) {
            isErrorFileSizeZero = true;
          } else {
            const istype = await this.checkFileType(file.type);
            if (istype) {
              let index = this.files.findIndex((v) => v.doc_code == key);
              if (index !== -1) {
                this.files[index].file = file;
                this.size = size;
              } else {
                showAlertError(
                  "ไฟล์มีปัญหา",
                  "พบไฟล์ชื่อ " +
                    this.files[index].file.name +
                    " ไม่สามารถเปิดไฟล์ได้"
                );
              }
              if (file.name === "image.jpg") {
                const newFile = this.renameFile(
                  file,
                  this.create_UUID() + ".png"
                );
                //Append to realFiles
                let tmpFile = {};
                tmpFile.id = this.create_UUID();
                tmpFile.type = docTypeItem.doc_code;
                tmpFile.name = docTypeItem.doc_name;
                tmpFile.file = newFile;
                tmpFile.status = false;
                tmpFile.filename = newFile.name;
                tmpFile.filesize = newFile.size;
                tmpFile.showPassword = false;
                tmpFile.floatingPassword = false;
                if ("image/heic" === newFile.type) {
                  this.convertHeicToJpg(
                    newFile,
                    docTypeItem.doc_code,
                    docTypeItem.doc_name
                  );
                } else if ("application/pdf" !== newFile.type) {
                  this.realFiles.push(tmpFile);
                } else {
                  this.validatePdfJS(tmpFile);
                  // this.validatePdf(tmpFile);
                }
              } else {
                let FilenameTmp = file.name;
                if (
                  file.name.slice(-4) == "heic" ||
                  file.name.slice(-4) == "HEIC"
                ) {
                  FilenameTmp = file.name.slice(0, -4) + "jpeg";
                }
                if (
                  this.realFiles.filter((i) => i.filename == FilenameTmp)
                    .length == 0
                ) {
                  //Append to realFiles
                  let tmpFile = {};
                  tmpFile.id = this.create_UUID();
                  tmpFile.type = docTypeItem.doc_code;
                  tmpFile.name = docTypeItem.doc_name;
                  tmpFile.file = file;
                  tmpFile.status = false;
                  tmpFile.filename = FilenameTmp;
                  tmpFile.filesize = file.size;
                  tmpFile.showPassword = false;
                  tmpFile.floatingPassword = false;

                  if ("image/heic" === file.type) {
                    this.convertHeicToJpg(
                      file,
                      docTypeItem.doc_code,
                      docTypeItem.doc_name
                    );
                  } else if ("application/pdf" !== file.type) {
                    this.realFiles.push(tmpFile);
                  } else {
                    this.validatePdfJS(tmpFile);
                    // this.validatePdf(tmpFile);
                  }
                } else {
                  filenameDup.push(file);

                  this.size = this.size - file.size;
                  isErrorFileNameDuplicate = true;
                }
              }
            } else {
              isErrorTypeFile = true;
            }
          }
        }
        //Handle error message
        let alert = null;
        if (isErrorSize && isErrorTypeFile) alert = this.alert.sizeAndTypeFile;
        else if (isErrorSize) alert = this.alert.size;
        else if (isErrorTypeFile) alert = this.alert.typefile;
        else if (isErrorEmptyFile) alert = this.alert.fileEmpty;
        else if (isErrorFileSizeZero) alert = this.alert.fileSizeZero;
        else if (isErrorFileNameDuplicate) {
          this.alertFilenameDuplicate(filenameDup);
        }
        if (alert) this.showAlertError(alert.title, alert.detail);
        try {
          document.getElementById("fileUpload").value = null;
          document.getElementById("fileCamera").value = null;
          document.getElementById("fileBrowseImage").value = null;
          document.getElementById("fileBrowseFile").value = null;
          document.getElementById("fileBrowseIOS").value = null;
        } catch (error) {
          console.error(error);
        }
      }
      const isError = (this.userData.documentType.find(
        (v) => v.doc_code == this.$route.params.doc_code
      ).state = "error");
      if (isError !== undefined) {
        this.saveLocalFile();
      }
    },
    getListFileByType() {
      return this.realFiles;
    },
    checkFileType(type) {
      switch (type) {
        case "application/pdf":
          return true;
        case "image/jpeg":
          return true;
        case "image/png":
          return true;
        case "image/heic":
          return true;
        default:
          return false;
      }
    },
    doSubmit() {
      this.saveLocalFile();
      if (this.isUploadStatement()) {
        this.goStatementDocument();
      } else {
        this.goPreUploadPage();
      }
    },
    saveLocalFile() {
      this.userData.documentType.find(
        (v) => v.doc_code == this.$route.params.doc_code
      ).filesReal = this.realFiles;
      if (this.realFiles.length > 0) {
        this.userData.documentType.find(
          (v) => v.doc_code == this.$route.params.doc_code
        ).state = "attachfile";
      } else {
        this.userData.documentType.find(
          (v) => v.doc_code == this.$route.params.doc_code
        ).state = "wait";
      }
      this.userData.document_group_type.find(
        (i) => i.grp_id == this.grp_id
      ).state = "addDocument";
    },
    remove(key) {
      let size = this.size;
      const item = this.realFiles.find((v) => v.id == key);
      if (item != undefined && !item.status && item.file != undefined) {
        size = size - item.file.size;
        this.size = size >= 0 ? size : 0;
        this.realFiles = this.realFiles.filter((v) => v.id != key);
      }
    },
    viewDoc(key) {
      const data = this.realFiles.find((v) => v.id == key);
      const file = data.file;
      if (file != undefined) {
        const url = URL.createObjectURL(file);
        window.open(
          url,
          "popUpWindow",
          "height=400,width=600,left=10,top=10,,scrollbars=yes,menubar=no"
        );
      }
    },
    getPreview(key) {
      const data = this.getListFileByType().find((v) => v.id == key);
      const file = data.file;
      if (file) {
        if ("application/pdf" === file.type) {
          return require("@/assets/images/ic_file_pdf.png");
        }

        return URL.createObjectURL(file);
      }
    },
    getFileType(key) {
      const data = this.getListFileByType().find((v) => v.id == key);
      const file = data.file;
      if (file) {
        if ("application/pdf" === file.type) {
          return "pdf";
        }

        return "img";
      }
    },
    getFileSize(fSize) {
      var fSExt = new Array("Bytes", "KB", "MB", "GB");
      var i = 0;
      while (fSize > 900) {
        fSize /= 1024;
        i++;
      }
      return (Math.round(fSize * 100) / 100).toFixed(1) + " " + fSExt[i];
    },
    goLandingPage() {
      this.$router.push({
        name: this.userData.routerPath.landing,
      });
    },
    removeFileByDocCode(e, docCode) {
      this.files.find((item) => item.doc_code == docCode).doc_has_deviate =
        e.target.checked;
      this.getListFileByType().forEach((item) => {
        this.remove(item.id);
      });
    },
    create_UUID() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    goPreUploadPage() {
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: this.userData.grpId },
      });
    },
    goStatementDocument() {
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    isUploadStatement() {
      let docGroup = this.userData.document_group_type.find(
        (i) => i.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      if (docGroup == undefined) return false;
      return docGroup.lst_doc_id.includes(this.$route.params.doc_code);
    },
    getAllSize() {
      let bytes = 0;
      this.realFiles.forEach((i) => {
        bytes = bytes + i.filesize;
      });
      return (bytes / (1024 * 1024)).toFixed(1);
    },
    getColorProgress() {
      if (this.getAllSize() > this.max) {
        return "danger";
      }
      return "";
    },
    checkLimit() {
      if (this.getAllSize() > this.max) {
        return false;
      }
      return true;
    },
    validatePdfCaseDuplicate(tmpFile, index) {
      let array = this.realFiles;
      const showAlertError = this.showAlertError;
      const fnShowModalPassword = this.openModalPdfPassword;

      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      var loadingTask = pdfjsLib.getDocument(URL.createObjectURL(tmpFile.file));

      loadingTask.promise.then(function () {
        array[index] = tmpFile;
      }).catch(function (error) {
        if (error !== undefined && error.name !== undefined) {
          if (error.name == "PasswordException") {
            tmpFile.fileHavePassword = true;
            tmpFile.fileCheckassword = null;
            fnShowModalPassword(tmpFile);
          } else if (error.name == "InvalidPDFException") {
            showAlertError(
              "ไฟล์มีปัญหา",
              "พบไฟล์ชื่อ " + tmpFile.file.name + " ไม่สามารถเปิดไฟล์ได้"
            );
          } else {
            showAlertError(error.name, error.message);
          }
        } else {
          tmpFile.fileHavePassword = true;
          tmpFile.fileCheckassword = null;
          fnShowModalPassword(tmpFile);
        }
      }).finally(function () {
        loadingTask.destroy();
      });
    },
    validateTotalPdf() {
      return this.realFiles.filter((item) => item.fileHavePassword).length == 0;
    },
    alertFilenameDuplicate(filenameDup) {
      let message =
        "พบเอกสารที่มีชื่อซ้ำกัน หากยืนยัน <br>ระบบจะบันทึกเอกสารทับเอกสารเดิม";
      let i = 0;
      filenameDup.forEach((p) => {
        if (i > 0) message += ",";
        message += '<br>"' + p.name + '"';
        i++;
      });
      this.$swal
        .fire({
          position: "center",
          title: "ยืนยันบันทึกเอกสารใหม่ <br/>ทับเอกสารเดิม?",
          html: message,
          padding: "1em",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "เลือกใหม่",
          confirmButtonColor: "#00A3E4",
          reverseButtons: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          buttonsStyling: false,
          customClass: {
            title: "swal-title-duplication-file",
            confirmButton:
              "btn btn-info  btn-swal-width btn-confirm-file-duplication",
            cancelButton:
              "btn btn-info btn-ktb-cancel btn-swal-width btn-cancel-file-duplication",
            htmlContainer: "html-container-file-duplication",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.updateFileDuplicate(filenameDup);
          }
        });
    },
    async updateFileDuplicate(files) {
      let key = this.$route.params.doc_code;

      let docTypeItem = this.userData.documentType.find(
        (v) => v.doc_code == key
      );
      for (let file of files) {
        const size = this.size + file.size;
        const istype = await this.checkFileType(file.type);
        if (istype) {
          let index = this.files.findIndex((v) => v.doc_code == key);
          if (index !== -1) {
            this.files[index].file = file;
            this.size = size;
          } else {
            alert("Error!. Please try again!");
          }
          //Append to realFiles
          let indexFile = -1;
          let tmpFile = {};
          for (var i = 0; i < this.realFiles.length; i++) {
            if (this.realFiles[i].filename == file.name) {
              tmpFile = this.realFiles[i];
              indexFile = i;
              break;
            }
          }

          if (indexFile > -1) {
            tmpFile.type = docTypeItem.doc_code;
            tmpFile.name = docTypeItem.doc_name;
            tmpFile.file = file;
            tmpFile.status = false;
            tmpFile.filename = file.name;
            tmpFile.filesize = file.size;
            if ("application/pdf" !== file.type) {
              this.realFiles[indexFile] = tmpFile;
            } else {
              this.validatePdfCaseDuplicate(tmpFile, indexFile);
            }
          }
        } else {
          // isErrorTypeFile = true;
        }
      }
    },
    showAlertError(title, message) {
      this.$swal.fire({
        position: "center",
        title: title,
        text: message,
        padding: "1em",
        confirmButtonText: "ตกลง",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        customClass: {
          title: "font-kanit-bold-24 text-kanit-color-black",
          confirmButton: "btn btn-block btn-submit-landing-page",
          htmlContainer: "html-container-custom",
        },
      });
    },
    checkDocIsSuccess() {
      const data = this.userData.documentType.find(
        (v) => v.doc_code == this.$route.params.doc_code
      );
      return data.state != undefined && data.state == "success";
    },
    checkDocIsError() {
      const data = this.userData.documentType.find(
        (v) => v.doc_code == this.$route.params.doc_code
      );
      return data.state != undefined && data.state == "error";
    },
    closeModalShowBackStep() {
      this.modalShowBackStep = false;
    },
    goToPreviousPage() {
      if (this.checkDocIsSuccess()) {
        this.$router.push({
          name: this.currentMenu.previousPage,
        });
        return;
      } else {
        if (
          this.realFiles.length == 0 &&
          this.userData.documentType.find(
            (v) => v.doc_code == this.$route.params.doc_code
          ).filesReal.length == 0
        ) {
          this.$router.push({
            name: this.currentMenu.previousPage,
          });
          return;
        } else {
          this.modalShowBackStep = true;
        }

        // let userDataRealFilesId = [];
        // let userDataRealFiles = this.userData.documentType.find(
        //   (v) => v.doc_code == this.$route.params.doc_code
        // ).filesReal;
        // userDataRealFiles.forEach((e) => userDataRealFilesId.push(e.id));
        // userDataRealFilesId.slice().sort();

        // let realFilesId = [];
        // this.realFiles.forEach((e) => realFilesId.push(e.id));
        // realFilesId.slice().sort();

        // let compare =
        //   userDataRealFilesId.length === realFilesId.length &&
        //   userDataRealFilesId
        //     .slice()
        //     .sort()
        //     .every(function (value, index) {
        //       return value === realFilesId[index];
        //     });
        // if (!compare) {
        //   this.modalShowBackStep = true;
        // } else {
        //   this.backPage();
        // }
      }
    },
    backPage() {
      // if (!this.validateTotalPdf()) {
      //   this.userData.documentType.find(
      //     (v) => v.doc_code == this.$route.params.doc_code
      //   ).filesReal = this.realFiles.filter((item) => !item.fileHavePassword);
      // }
      this.userData.documentType.find(
        (v) => v.doc_code == this.$route.params.doc_code
      ).filesReal = [];

      this.userData.documentType.find(
        (v) => v.doc_code == this.$route.params.doc_code
      ).state = "wait";

      this.userData.document_group_type.find(
        (i) => i.grp_id == this.grp_id
      ).state = "wait";

      let param = this.currentMenu.params;
      if (param != undefined && param.grpId != undefined) {
        this.$router.push({
          name: this.currentMenu.previousPage,
          params: { grpId: param.grpId },
        });
      }
    },
    calcHeight() {
      var h = window.innerHeight;
      return h < 680;
    },
    setIsConvertingHeic(value) {
      this.isConvertingHeic = value;
    },
    convertHeicToJpg(fileHeic, docCode, docName) {
      const showAlertError = this.showAlertError;
      const create_UUID = this.create_UUID;
      const setConvertingHeic = this.setIsConvertingHeic;
      const realFiles = this.realFiles;
      setConvertingHeic(true);
      var fileName =
        fileHeic.name.substring(0, fileHeic.name.lastIndexOf(".") + 1) ||
        fileHeic.name;
      var reader = new FileReader();
      reader.onload = function () {
        const blob = new Blob([reader.result], { type: "image/heic" });
        const data = heic2any({ blob, toType: "image/jpeg" });
        data
          .then((conversionResult) => {
            const file = new File([conversionResult], fileName + "jpeg", {
              type: "image/jpeg",
            });
            let tmpFile = {};
            tmpFile.id = create_UUID();
            tmpFile.type = docCode;
            tmpFile.name = docName;
            tmpFile.file = file;
            tmpFile.status = false;
            tmpFile.filename = file.name;
            tmpFile.filesize = file.size;
            realFiles.push(tmpFile);

            setConvertingHeic(false);
          })
          .catch((e) => {
            setConvertingHeic(false);
            console.log(e);
            showAlertError(
              "แปลงสกุลไฟล์ .heic  ไม่สำเร็จ",
              "กรุณาลองใช้ไฟล์นามสกุลเช่น JPG หรือ PNG"
            );
          });
      };
      reader.readAsArrayBuffer(fileHeic);
    },
    onShowPassword(item) {
      if (item.showPassword) {
        item.showPassword = false;
      } else {
        item.showPassword = true;
      }
      this.$forceUpdate();
    },
    renameFile(originalFile, newName) {
      return new File([originalFile], newName, {
        type: "image/png",
        lastModified: originalFile.lastModified,
      });
    },
    closeModalPdfPassword() {
      this.modalPassword = false;
      this.tmpFilePassword = {};
      this.$forceUpdate();
    },
    openModalPdfPassword(fileBean) {
      this.tmpFilePassword = fileBean;
      this.tmpFilePassword.input_password = "";
      this.tmpFilePassword.floatingPassword = false;
      this.modalPassword = true;
      this.$forceUpdate();
    },
    onblurModalPdfPassword() {
      this.tmpFilePassword.floatingPassword =
        this.tmpFilePassword.input_password.length != 0;
      this.tmpFilePassword.fileCheckassword = null;

      this.$forceUpdate();
    },
    validateModalPdfPassword(tmpFilePassword) {
      const fnCloseModal = this.closeModalPdfPassword;
      const fnPushFile = this.pushFile;
      try {
        if (this.userData.isAndroid) {
          setTimeout(() => {
            tmpFilePassword.fileCheckassword = false;
            this.$forceUpdate();
          }, 500);
        } else {
          setTimeout(() => {
            tmpFilePassword.fileCheckassword = false;
            this.$forceUpdate();
          }, 100);
        }

        const password = tmpFilePassword.input_password;
        tmpFilePassword.floatingPassword = password.length != 0;
        this.$forceUpdate();

        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
        var loadingTask = pdfjsLib.getDocument(URL.createObjectURL(tmpFilePassword.file));

        loadingTask.onPassword = function (updatePassword, reason) { 
          if (reason === 1) { // need a password
            console.log("Need Password")
            updatePassword(password);
          } else { // Invalid password
            console.log("Invalid Password")
            throw new Error("Invalid Password");
          }
        };

        loadingTask.promise.then(function () {
          tmpFilePassword.fileCheckassword = true;
          tmpFilePassword.fileHavePassword = false;
          tmpFilePassword.password = password;
          fnPushFile(tmpFilePassword);
          fnCloseModal();
        }).catch(function (error) {
          console.log("catch", error);
          tmpFilePassword.fileCheckassword = false;
        }).finally(function () {
          loadingTask.destroy();
        });
        
      } catch (error) {
        console.error(error);
      }
    },
    pushFile(itemFile) {
      let indexFile = -1;
      for (var i = 0; i < this.realFiles.length; i++) {
        if (this.realFiles[i].filename == itemFile.filename) {
          indexFile = i;
          break;
        }
      }

      if (indexFile > -1) {
        this.realFiles[indexFile] = itemFile;
      } else {
        this.realFiles.push(itemFile);
      }
    },
    validateFileHavePassword(tmpFile, event) {
      tmpFile.floatingPassword = event.target.value.length != 0;
      try {
        tmpFile.fileCheckassword = false;
        const password = event.target.value;

        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
        var loadingTask = pdfjsLib.getDocument(URL.createObjectURL(tmpFilePassword.file));

        loadingTask.onPassword = function (updatePassword, reason) { 
          if (reason === 1) { // need a password
            console.log("Need Password")
            updatePassword(password);
          } else { // Invalid password
            console.log("Invalid Password")
            throw new Error("Invalid Password");
          }
        };

        loadingTask.promise.then(function () {
          tmpFile.fileHavePassword = false;
          tmpFile.fileCheckassword = true;
          tmpFile.password = password;
        }).finally(function () {
          loadingTask.destroy();
        });
        
      } catch (error) {
        console.log("PDF : " + tmpFile)
        console.error(error);
      }
      this.$forceUpdate();
    },
    validatePdfJS(tmpFile) {

      let array = this.realFiles;
      const showAlertError = this.showAlertError;
      const fnShowModalPassword = this.openModalPdfPassword;

      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      var loadingTask = pdfjsLib.getDocument(URL.createObjectURL(tmpFile.file));

      loadingTask.promise
        .then(function () {
          array.push(tmpFile);
        })
        .catch(function (error) {
          if (error !== undefined && error.name !== undefined) {
            if (error.name == "PasswordException") {
              tmpFile.fileHavePassword = true;
              tmpFile.fileCheckassword = null;
              fnShowModalPassword(tmpFile);
              //array.push(tmpFile);
            } else if (error.name == "InvalidPDFException") {
              console.error(error);
              showAlertError(
                "ไฟล์มีปัญหา",
                "พบไฟล์ชื่อ " + tmpFile.file.name + " ไม่สามารถเปิดไฟล์ได้"
              );
            } else {
              showAlertError(error.name, error.message);
            }
          } else {
            tmpFile.fileCheckassword = null;
            tmpFile.fileHavePassword = true;
            //array.push(tmpFile);
            fnShowModalPassword(tmpFile);
          }
        })
        .finally(function () {
          loadingTask.destroy();
        });
    },
  },
};
</script>
<style>
.btn-swal-width {
  width: 45%;
  margin-left: 0.5rem;
}
a {
  color: black;
  text-decoration: none;
}
a:hover,
a:focus {
  color: black;
  text-decoration: none;
}
.deviate-text {
  color: #ff6961;
  font-size: 0.75rem;
}
.document-info > .title {
  color: #00a3e4;
}
.document-info > .header {
  color: #000000;
}
.document-info > .body {
  color: #8e94a4;
}
.btn-upload-true {
  background-color: #3f62f1 !important;
  color: #3c68ce !important;
  border-color: #e3e4e8 !important;
}
.btn-ktb-deviate {
  background-color: white !important;
  color: #df0747 !important;
  border-color: #f93972 !important;
}
.btn-goback {
  background-color: white !important;
  color: #00a3e4 !important;
  border-color: #00a3e4 !important;
}
.text-upload-true {
  color: #aaafbb !important;
}
.alert-warning {
  color: #b98f13;
  background-color: #fdf8e7;
  border-color: #ffeeba;
  border-left-color: #f5d470;
  border-left-width: 4px;
}
.text-blue {
  color: rgb(0, 166, 230) !important;
}
.status-color-2 {
  color: #daa60b !important;
}
.status-color-3 {
  color: #479e6a !important;
}
.status-color-6 {
  color: #aaafbb !important;
}
.status-color-5,
.status-color-1,
.status-color-4 {
  color: #df0747 !important;
}
.progress-upload-custom {
  height: 0.4rem !important;
  width: 100%;
  background-color: #f8f8f8 !important;
}
.progress-bar {
  background-color: #4457e3;
}
.progress-bar > .bg-danger {
  background-color: rgb(219, 0, 0);
}
.use-memory {
  text-align: center;
}
.size-memory {
  margin: 0;
  font-family: KrungthaiFast-Bold, Arial, sans-serif !important;
  color: rgb(0, 166, 230) !important;
  font-size: 14px !important;
}
.badge-primary {
  border: 1.5px solid #33c5ff;
  box-sizing: border-box;
  position: absolute;
  margin: -10px 0px;
  margin-top: 0rem;
  color: #33c5ff;
  background-color: transparent;
  width: 20px;
  height: 20px;
}
.text-document {
  color: #919595;
}
.upload-button {
  background: #ffffff;
  /* Color/Fill/Paotang/Paotang-Normal */
  box-sizing: border-box;
  border: 2px dashed #4457e3;
  border-radius: 8px;
  width: 100%;
  height: 66px;
}
.body-style {
  padding-left: 0px;
  padding-right: 0px;
}
.preview-img {
  width: 43px;
  border: 1px solid rgb(188, 204, 214);
  border-radius: 8px;
}
.preview-pdf {
  width: 43px;
  height: 43px;
  border-radius: 5px;
  background: rgba(242, 242, 242, 1);
}
.view-example {
  text-decoration: underline;
  color: #087ffd !important;
}
.text-danger {
  text-align: center;
  color: rgb(219, 0, 0);
  font-family: KrungthaiFast-Regular, Arial, sans-serif !important;
  font-size: 14px !important;
}
.btn-secondary.disabled,
.btn-secondary:disabled {
  background-color: #8e94a4 !important;
  border-color: #8e94a4 !important;
  background-image: linear-gradient(-90deg, #00b3f0, #006a9e) !important;
}
.danger-true {
  color: rgb(219, 0, 0);
}
.content-nowrap {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: unset;
}
.card-doc-err {
  background-color: #feeee3;
  border-radius: 16px !important;
  border: 1px solid #feeee3;
  margin-bottom: 10px;
  box-shadow: 0px 2px 4px 0px rgb(188, 204, 214, 0.4) !important;
}
.card-doc-err-detail {
  color: #e17f00;
}
.format-pre pre {
  background: #49483e;
  color: #f7f7f7;
  padding: 10px;
  font-size: 14px;
}
.modal-dialog-centered {
  display: grid;
  align-items: end;
  min-height: calc(100% - 1rem);
}
.btn-noborder {
  background-color: #ffffff;
  border-color: #ffffff;
  color: black;
}
.vl {
  border-left: 1px solid gray;
  height: 100px;
}
.btn-back-step {
  width: inherit;
  color: #00a3e4;
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius: unset;
}
.text-header-center {
  text-align: center;
  font-size: 20px;
}
.icon-back {
  color: #00a7ec;
}
.badge-ktb-info {
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}
.badge-primary {
  border: 2px solid rgb(0, 166, 230);
  box-sizing: border-box;
  position: absolute;
  margin: -10px 0px;
  margin-top: 2px;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}
.modal-attachfile-modal_content {
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 16px 16px 0 0;
  outline: 0;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
}
.uploads-content-card-md {
  min-height: 43%;
}
.uploads-content-card-sm {
  min-height: 23%;
}
.form-control.is-invalid,
.was-validated .form-control:invalid {
  background-image: unset !important;
}
.html-container-file-duplication {
  line-height: 24px !important;
  letter-spacing: -0.5px !important;
}
.swal2-title {
  position: relative;
  max-width: 100%;
  margin: 0;
  /* padding: 0.8em 1em 0; */
  color: inherit;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}
.swal-title-duplication-file {
  font-family: Kanit-Bold, Arial, sans-serif !important;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #212121 !important;
}
.password-icon-false {
  float: right;
  margin-left: -30px;
  margin-top: -45px;
  margin-right: 5px;
  position: relative;
  z-index: 2;
}
.password-icon-true {
  float: right;
  margin-left: -30px;
  margin-top: -35px;
  margin-right: 5px;
  position: relative;
  z-index: 2;
}
.form-control.is-invalid,
.was-validated .form-control:invalid {
  background-image: unset !important;
  font-family: Kanit-Regular;
}
input:focus ~ .floating-label-false {
  top: 8px;
  bottom: 10px;
  left: 20px;
  font-size: 14px !important;
  font-family: Kanit-Regular;
  opacity: 1;
  color: #4457e3;
}
.floating-label-false {
  position: absolute;
  pointer-events: none;
  left: 20px;
  top: 18px;
  font-size: 20px !important;
  transition: 0.2s ease all;
  font-family: Kanit-Regular;
  color: #838383;
}
.floating-label-true {
  position: absolute;
  pointer-events: none;
  top: 8px;
  bottom: 10px;
  left: 20px;
  font-size: 14px !important;
  opacity: 1;
  transition: 0.2s ease all;
  font-family: Kanit-Regular;

  color: #4457e3;
}

.form-control {
  height: calc(1.5em + 0.75rem + 30px);
  border-radius: 8px !important ;
}
.floating-text-true {
  color: #00a408;
}
.floating-text-false {
  color: #dc3545;
}
</style>
<style scoped>
.swal2-html-container {
  z-index: 1 !important;
  justify-content: center !important;
  margin: 1em 1.6em 0.3em !important;
  padding: 0 !important;
  overflow: auto !important;
  color: #212121 !important;
  font-size: 1.125em !important;
  font-weight: normal !important;
  line-height: normal !important;
  text-align: center !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
}
.btn-submit-landing-page {
  font-size: 18px !important;
  height: 46px !important;
  border-radius: 8px !important;
  font-family: Kanit-Bold, Arial, sans-serif !important;
  color: white !important;
  background: linear-gradient(274.84deg, #4457e3 0%, #5367ff 100%) !important;
}

.btn-submit-landing-page.disabled,
.btn-submit-landing-page:disabled {
  color: #ffffff !important;
  background-color: #e0e0e0 !important;
  border-color: #e0e0e0 !important;
  background-image: none !important;
}
.hr-style {
  border: 1px solid #f2f2f2 !important;
}
</style>
